<template>
  <div
    class="IconButton btn"
    @click="$emit('click')">
    <div class="label">
      <slot />
    </div>
    <div class="icon">
      <Icon :name="icon" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: "send",
    },
  },
};
</script>

<style lang="scss" scoped>
.IconButton {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .label {
    padding-right: 1em;
  }
}
</style>
